import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-per-curiosi',
  templateUrl: './per-curiosi.component.html',
  styleUrls: ['./per-curiosi.component.css']
})
export class PerCuriosiComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
